<div class="height-container">
    <ion-content class="ion-padding" [hidden]="isSignUp || islogin">
        <div class="grid-wrap">
            <ion-grid class="sign-grid">
                <img class="sopo" src="assets/img/SOPO-white.webp" alt="sopo-logo" />

                    <ng-container *ngIf="isElectronApp; else oauthButtons">
                        <app-qr-login></app-qr-login>
                    </ng-container>

                    <ng-template #oauthButtons>
                    <ion-row>
                        <ion-col>
                            <ion-label class="login-seperator"><span>Login with</span></ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col class="login-col">
                            <div *ngIf="facebookLoginEnabled" [ngClass]="{'blue-red-theme' : theme === 'blue-red-theme'}" class="facebook btn" title="Facebook" (click)="facebookLogin()">
                                <img src="/assets/icon/facebook.svg" alt="facebook-logo" />
                            </div>
                            <div [ngClass]="{'blue-red-theme' : theme === 'blue-red-theme'}" class="google btn" title="Google" (click)="googleLogin()">
                                <ion-icon name="logo-google"></ion-icon>
                            </div>
                            <div [ngClass]="{'blue-red-theme' : theme === 'blue-red-theme'}" class="apple btn" title="Apple" (click)="appleLogin()">
                                <ion-icon name="logo-apple"></ion-icon>
                            </div>
                            <div [ngClass]="{'blue-red-theme' : theme === 'blue-red-theme'}" *ngIf="!desktopConfig" class="abstract btn" title="Abstract" (click)="walletLogin('abstract')">
                                <img src="/assets/icon/abstract_logo.webp">
                            </div>
                        </ion-col>
                    </ion-row>
                    </ng-template>

                    <ng-container *ngIf="!isElectronApp">
                    <ion-row class="login-details">
                    <form [formGroup]="loginForm" (ngSubmit)="emailLogin()">
                        <div class="form form-login">
                            <ion-row>
                                <ion-col>
                                    <ion-item class="input-item" lines="none">
                                        <ion-input
                                            mode="md"
                                            type="email"
                                            placeholder="Email"
                                            formControlName="email"
                                            autofocus="true"
                                            autocomplete="email"
                                        ></ion-input>
                                    </ion-item>
                                </ion-col>
                            </ion-row>
                            <ng-container *ngFor="let validation of validationMessages.email">
                                <div class="ion-text-center error"
                                    *ngIf="loginForm.get('email').hasError(validation.type) && loginErroFlag">
                                    {{ validation.message }}
                                </div>
                            </ng-container>
                            <ion-row>
                                <ion-col>
                                    <ion-item class="input-item" lines="none">
                                        <ion-input
                                            (keyup.enter)="emailLogin()"
                                            mode="md"
                                            type="password"
                                            placeholder="Password"
                                            formControlName="loginPassword"
                                            autocomplete="current-password"
                                            class="password-input"
                                        ></ion-input>
                                    </ion-item>
                                </ion-col>
                            </ion-row>
                            <ng-container *ngFor="let validation of validationMessages.loginPassword">
                                <div class="ion-text-center error"
                                    *ngIf="loginForm.get('loginPassword').hasError(validation.type) && loginErroFlag">
                                    {{ validation.message }}
                                </div>
                            </ng-container>
                            <ion-row>
                                <ion-col class="login-btn">
                                    <ion-button
                                        class="email-btn"
                                        type="submit"
                                        shape="round"
                                        expand="full"
                                    >
                                        <span>Login</span>
                                    </ion-button>
                                </ion-col>
                            </ion-row>
                            <ng-container *ngIf="showLoginInfos">
                                <ion-row>
                                    <ion-col class="login-btn" *ngIf="createTableOption">
                                        <ion-button class="email-btn anonymus-btn" (click)="guestLogin()" shape="round" expand="full">
                                            <span>Create Table As Guest</span>
                                        </ion-button>
                                    </ion-col>
                                </ion-row>
                            </ng-container>
                                <ion-row>
                                    <ion-col class="login-btn login-w-signup">
                                        <span class="forgot-password" (click)="forgotPassword()">Forgot Password?</span>
                                    </ion-col>
                                </ion-row>
                                <ng-container *ngIf="showLoginInfos">
                                    <ion-row>
                                        <ion-col class="login-btn login-w-signup">
                                            <span>
                                                Don't have an account?
                                                <span class="guest" (click)="displaySignUp()">Register</span>
                                            </span>
                                        </ion-col>
                                    </ion-row>
                                </ng-container>
                        </div>
                    </form>

                    </ion-row>
                    </ng-container>

                    <ion-row>
                        <ion-col class="login-btn login-w-signup">
                            <span class="forgot-password" (click)="openAppBrowser('https://playsopo.com/#/privacy-policy/')">Privacy Policy</span>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col class="login-btn login-w-signup">
                            <span class="forgot-password" (click)="openAppBrowser('https://playsopo.com/#/terms-of-service/')">Terms of service</span>
                        </ion-col>
                    </ion-row>
            </ion-grid>
        </div>
    </ion-content>

    <ion-content class="ion-padding" [hidden]="!isSignUp || isElectronApp">
        <div class="grid-wrap">
            <ion-grid class="sign-grid">
                <img class="sopo" src="assets/img/SOPO-white.webp" />
                <ion-row>
                    <ion-col>
                        <ion-label class="login-seperator reg-seperator"><span>Create an account</span></ion-label>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col class="login-col">
                        <div *ngIf="facebookLoginEnabled" class="facebook btn" (click)="facebookLogin()">
                            <img src="/assets/icon/facebook.svg" alt="facebook-logo" />
                        </div>
                        <div class="google btn" (click)="googleLogin()">
                            <ion-icon name="logo-google"></ion-icon>
                        </div>
                        <div class="apple btn" (click)="appleLogin()">
                            <ion-icon name="logo-apple"></ion-icon>
                        </div>
                        <div class="abstract btn" *ngIf="!desktopConfig" (click)="walletLogin('abstract')">
                            <img src="/assets/icon/abstract_logo.webp">
                        </div>
                    </ion-col>
                </ion-row>

                <form [formGroup]="registrationForm" (ngSubmit)="signUp()">
                    <div class="form form-registration">
                        <ion-row>
                            <ion-col>
                                <ion-item class="input-item" lines="none">
                                    <ion-input
                                        mode="md"
                                        type="email"
                                        placeholder="Email"
                                        formControlName="email"
                                        autofocus="true"
                                        autocomplete="email"
                                    ></ion-input>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                        <ng-container *ngFor="let validation of validationMessages.email">
                            <div class="ion-text-center error"
                                *ngIf="registrationForm.get('email').hasError(validation.type) && registrationForm.get('email').touched">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <ion-row>
                            <ion-col>
                                <ion-item class="input-item" lines="none">
                                    <ion-input
                                        class="password-input"
                                        mode="md" type="password"
                                        placeholder="Password"
                                        formControlName="password"
                                        autocomplete="new-password"
                                    ></ion-input>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                        <ng-container *ngFor="let validation of validationMessages.password">
                            <div class="ion-text-center error"
                                *ngIf="registrationForm.get('password').hasError(validation.type) && registrationForm.get('password').touched">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <ion-row>
                            <ion-col>
                                <ion-item class="input-item" lines="none">
                                    <ion-input
                                        class="password-input"
                                        mode="md" type="password"
                                        placeholder="Confirm Password"
                                        formControlName="confirmPassword"
                                        autocomplete="new-password"
                                    ></ion-input>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                        <ng-container *ngFor="let validation of validationMessages.confirmPassword">
                            <div class="ion-text-center error"
                                *ngIf="registrationForm.get('confirmPassword').hasError(validation.type) && registrationForm.get('confirmPassword').touched">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <ng-container *ngIf="desktopConfig">
                            <ion-row>
                                <ion-col>
                                    <ion-item lines="none" class="input-item">
                                        <ion-input
                                            formControlName="inviteCode"
                                            placeholder="Invite Code"
                                            autocomplete="off"
                                        ></ion-input>
                                    </ion-item>
                                </ion-col>
                            </ion-row>
                            <ng-container *ngFor="let validation of validationMessages.inviteCode">
                                <div class="ion-text-center error"
                                    *ngIf="registrationForm.get('inviteCode').hasError(validation.type)">
                                    {{ validation.message }}
                                </div>
                            </ng-container>
                        </ng-container>
                        <div class="validation-error">
                            <div class="checkbox" [ngClass]="{
                                'checkbox-error': (registrationErrorFlag && !acceptPrivacy.value || registrationErrorFlag && !acceptTerms.value)
                            }">
                                <div class="checkbox-and-text" (click)="openAgreeComponent('PP')" >
                                    <ion-icon name="checkmark-circle" color="success" *ngIf="(acceptPrivacy | async) else emptyCheckbox"></ion-icon>
                                    Privacy Policy
                                    <span class="error" *ngIf="registrationErrorFlag && !acceptPrivacy.value">Required</span>
                                </div>
                                <div class="checkbox-and-text" (click)="openAgreeComponent('TOS')">
                                    <ion-icon name="checkmark-circle" color="success" *ngIf="(acceptTerms | async) else emptyCheckbox"></ion-icon>
                                    Terms of service
                                    <span class="error" *ngIf="registrationErrorFlag && !acceptTerms.value">Required</span>
                                </div>
                            </div>
                        </div>
                        <span class="terms-label-text"
                            [ngClass]="{
                                'terms-label-visibile': (!acceptPrivacy.value || !acceptTerms.value)
                            }"
                    >
                        You must agree to both options above to register.
                    </span>
                        <ion-row>
                            <ion-col class="login-btn">
                                <ion-button
                                type="submit"
                                class="email-btn"
                                shape="round"
                                expand="full"
                                [disabled]="!registrationForm.valid || !acceptPrivacy.value || !acceptTerms.value"
                                ><span>Register</span>
                            </ion-button>
                        </ion-col>
                    </ion-row>
                        <ion-row *ngIf="!isQuickplay">
                            <ion-col class="login-btn login-w-signup">
                                <span><span class="guest" (click)="displayLogin()">Back to Login</span></span>
                            </ion-col>
                        </ion-row>
                    </div>
                </form>

            </ion-grid>
        </div>
    </ion-content>

    <ion-content class="ion-padding" [hidden]="!islogin">
        <img class="sopo" src="assets/img/SOPO-white.webp" />
        <ion-row>
            <ion-col class="login-btn">
                <ion-button class="email-btn" (click)="displayLogin()" shape="round" expand="full"
                    ><span>Back to Login Options</span></ion-button
                >
            </ion-col>
        </ion-row>
    </ion-content>
</div>
<ng-template #emptyCheckbox><ion-icon name="checkmark-circle" color="medium"></ion-icon></ng-template>
